module.exports = __webpack_public_path__ + "static/media/dev-technologies.78b669ce.svg";